<template>
  <div class="content-wrapper">
    <section class="plan-form">
      <PlanEditForm/>
    </section>
  </div>
</template>

<script>
import PlanEditForm from '@/components/plan/PlanEditForm.vue'

export default {
  name: 'PlanEdit',
  components: {
    PlanEditForm
  }
}
</script>
